// extracted by mini-css-extract-plugin
module.exports = {"container":"languageDropdown_container__1Ilzs","arrowDown":"languageDropdown_arrowDown__108hK","dropdown":"languageDropdown_dropdown__W1BSA"};